import { handleToggleComments } from './comment.js';

export function initHighlightHandlers(config) {
  // Format timestamps on initial load
  applyTimestamps();

  // Delay the immediate highlight logic so that feed items and toggles exist
  setTimeout(() => {
    handleHighlight(config);
  }, 500);
}

export function applyTimestamps() {
  const timeSpans = document.querySelectorAll('.post-time[data-raw-timestamp]');
  timeSpans.forEach((span) => {
    const raw = span.getAttribute('data-raw-timestamp');
    span.textContent = formatTimestamp(raw);
  });
}

export function formatTimestamp(utcString) {
  if (!utcString) return '';
  if (!utcString.includes('T')) {
    const [datePart, timePart] = utcString.split(' ');
    if (!datePart || !timePart) return utcString;
    utcString = `${datePart}T${timePart}Z`;
  }
  const dt = new Date(utcString);
  if (isNaN(dt)) {
    console.warn(`Invalid date format: ${utcString}`);
    return utcString;
  }
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  return dt.toLocaleString(undefined, options);
}

export function handleHighlight(config) {
  const params = new URLSearchParams(window.location.search);
  const highlightRating = params.get('highlight_rating');
  const highlightComment = params.get('highlight_comment');

  if (highlightRating) {
    const ratingEl = document.getElementById(`rating-${highlightRating}`);
    if (ratingEl) {
      moveFeedItemToTop(ratingEl);
      if (!highlightComment) {
        highlightElement(ratingEl, 'rating');
      }
      if (highlightComment) {
        const toggleCommentsBtn = ratingEl.querySelector('.comments-toggle');
        if (toggleCommentsBtn) {
          handleToggleComments(toggleCommentsBtn, config).then(() => {
            attemptHighlightComment(highlightComment, config);
          });
        }
      }
    }
  }

  if (highlightComment && !highlightRating) {
    attemptHighlightComment(highlightComment, config);
  }
}

/**
 * Try to highlight a specific comment in the DOM.
 * Returns TRUE if found & highlighted, FALSE otherwise.
 */
export function attemptHighlightComment(commentId, config) {
  const commentEl = document.getElementById(`comment-${commentId}`);
  if (!commentEl) return false;

  const commentsSection = commentEl.closest('.comments-section');
  if (
    commentsSection &&
    (commentsSection.classList.contains('hidden') ||
      commentsSection.style.display === 'none')
  ) {
    const ratingId = commentsSection.id.replace('comments-', '');
    const toggleCommentsBtn = document.querySelector(
      `#rating-${ratingId} .comments-toggle`
    );
    if (toggleCommentsBtn) {
      return handleToggleComments(toggleCommentsBtn, config).then(() => {
        scrollToAndHighlight(commentEl, 'comment');
        return true;
      });
    }
  } else {
    scrollToAndHighlight(commentEl, 'comment');
    return true;
  }
  return false;
}

export function scrollToAndHighlight(el, type = 'comment') {
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  highlightElement(el, type);
}

export function highlightElement(el, type = 'comment') {
  const highlightClass = type === 'rating' ? 'highlight-rating' : 'highlight-comment';
  el.classList.add(highlightClass);
  setTimeout(() => {
    el.classList.remove(highlightClass);
  }, 3000);
}

export function moveFeedItemToTop(feedItem) {
  const feedContainer = document.getElementById('feed');
  if (!feedContainer || !feedContainer.contains(feedItem)) return;
  feedContainer.insertBefore(feedItem, feedContainer.firstChild);
}
